import { render, staticRenderFns } from "./GlobalRnd.vue?vue&type=template&id=87d16324&scoped=true&"
import script from "./GlobalRnd.vue?vue&type=script&lang=js&"
export * from "./GlobalRnd.vue?vue&type=script&lang=js&"
import style0 from "./GlobalRnd.vue?vue&type=style&index=0&id=87d16324&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d16324",
  null
  
)

export default component.exports